export default __webpack_public_path__ + "static/neue-haas-grotesk-display-56-roman-italic-5279cb4f93e206c5274831fb7b908d6b.woff2";